var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.project.name)?[(_vm.showAdmin)?_c('Admin',{attrs:{"projectProps":_vm.project}}):_vm._e(),(!_vm.showAdmin)?_c('Project',{attrs:{"projectProps":_vm.project}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }